import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { IMoney } from '../../../../../../../../../common/model/IMoney';
import featureColorNameStyles from './featureColorNameStyles';
import FeatureColorPrice from '../featureColorPrice/FeatureColorPrice';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';

export interface IFeatureColorNameProps {
  title: string;
  isSummary?: boolean;
  featureId: string;
  price?: IMoney;
}

const FeatureColorName: FC<IFeatureColorNameProps> = ({ title, isSummary, featureId, price }) => {
  const styles = featureColorNameStyles();

  const {
    platformConfig: { showInteriorAndExteriorPrice },
  } = usePlatformConfig();

  return (
    <Typography
      component={'span'}
      variant={'caption'}
      className={isSummary ? styles.selectedFeatureTitle : styles.featureTitle}
      data-test={`summary:selected:featureTitle:${featureId}`}
    >
      {title}
      {showInteriorAndExteriorPrice && (
        <>
          {' '}
          <FeatureColorPrice price={price} />
        </>
      )}
    </Typography>
  );
};

export default FeatureColorName;
